<div class="modal-dialog modal-dialog-scrollable">
  <div class="modal-content">
    <div class="modal-header bg-primary text-white px-4">
      <h4 class="modal-title">{{ title }}</h4>
      <button type="button" class="close text-white" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true"><app-icon name="times"></app-icon></span>
      </button>
      </div>
      <div class="modal-body">
      {{ message }}
    </div>
    <div class="modal-footer action-btn-wrap">
      <button type="button" class="btn btn-gray font-sm" (click)="decline()">
        {{ btnCancelText ? btnCancelText : 'Cancel' }}
      </button>
      <button type="button" class="btn btn-primary font-sm" (click)="accept()">{{ btnOkText }}</button>
    </div>
  </div>
</div>